var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTsGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#44bba4;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0-221v35H70v-70H0Z",
    transform: "translate(0 256)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.958,30.288l.023-3.02h-9.6V0H9.6V27.269H0V30.23a29.019,29.019,0,0,0,.082,3.043c.035.047,5.875.07,12.956.058L25.923,33.3Z",
    transform: "translate(40.99 63.667) rotate(180)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M168.6-235.022a9.177,9.177,0,0,1,4.611,2.657A12.145,12.145,0,0,1,174.978-230c.023.094-3.183,2.247-5.126,3.453-.07.047-.351-.257-.667-.726a4.179,4.179,0,0,0-3.464-2.083c-2.235-.152-3.675,1.018-3.663,2.973a2.7,2.7,0,0,0,.316,1.381c.492,1.018,1.4,1.627,4.272,2.867,5.278,2.27,7.537,3.768,8.941,5.9a10.7,10.7,0,0,1,.854,8.988c-1.17,3.066-4.073,5.149-8.157,5.84a22.594,22.594,0,0,1-5.617-.058,13.547,13.547,0,0,1-7.5-3.909,13.026,13.026,0,0,1-1.919-2.844,5.494,5.494,0,0,1,.679-.433c.328-.187,1.569-.9,2.739-1.58l2.118-1.229.445.655a9.9,9.9,0,0,0,2.8,2.68c2.352,1.24,5.583,1.065,7.174-.363a2.713,2.713,0,0,0,.96-2.212,2.7,2.7,0,0,0-.55-1.872c-.573-.819-1.744-1.51-5.068-2.949-3.8-1.638-5.442-2.657-6.94-4.272a9.721,9.721,0,0,1-2.025-3.687,14.765,14.765,0,0,1-.129-4.7,8.986,8.986,0,0,1,7.56-7A18.682,18.682,0,0,1,168.6-235.022Z",
    transform: "translate(-112.837 265.308)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsGreen);
export default __webpack_public_path__ + "static/media/ts-green.b389c2e9652bb57af2446b7ec9ea69ec.svg";
export { ForwardRef as ReactComponent };